import {
  getInfo
} from '@/api/user'
import {
  removeToken
} from '@/utils/auth'

const state = {
  userInfo: {}
}

const mutations = {
  SET_USERINFO: (state, value) => {
    state.userInfo = value
  }
}

const actions = {
  getInfo({
    commit,
    state
  }, mustLoad) {
    return new Promise((resolve, reject) => {
      if (!mustLoad && (JSON.stringify(state.userInfo) !== '{}')) {
        resolve()
        return
      }
      getInfo().then((params) => {
        const data = params ? params.data : null
        commit('SET_USERINFO', data)
        // localStorage.setItem('userinfo', JSON.stringify(data))
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({
    commit
  }) {
    return new Promise((resolve, reject) => {
      commit('SET_USERINFO', {})
      removeToken()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
